<template>

    <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" ref="form">

        <input type="hidden" name="stay-on-page" v-model="stayOnPage">

        <div class="form-group">
            <label for="name">Nazwa</label>
            <input type="text" class="form-control" id="name" v-model="form.name">
            <span class="error mt-2 text-danger" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
        </div>

        <div class="form-group">
            <label for="description">Opis</label>
            <textarea id="description" class="form-control" rows="3" v-model="form.description"></textarea>
            <span class="error mt-2 text-danger" v-if="form.errors.has('description')" v-text="form.errors.get('description')"></span>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-8">
                <div class="form-group">
                    <label class="pb-3" for="description">Uprawnienia</label>

                    <div class="mb-5" v-for="permissionGroup in permissions">
                        <table class="table">
                            <tr>
                                <th style="width: 40%;">{{ permissionGroup.name }}</th>
                                <th class="text-center" style="width: 20%;">Odczyt (dostęp)</th>
                                <th class="text-center" style="width: 20%;">Modyfikacja</th>
                            </tr>
                            <tr v-for="permission in permissionGroup.permissions">
                                <td>{{ permission.name }}</td>
                                <td class="text-center">
                                    <div class="custom-control custom-checkbox" v-if="permission.actions.includes('show')">
                                        <input type="checkbox" class="custom-control-input" :id="permissionGroup.identifier + '.' + permission.identifier + '.show'" v-model="form.permissions" :value="permissionGroup.identifier + '.' + permission.identifier + '.show'">
                                        <label class="custom-control-label" :for="permissionGroup.identifier + '.' + permission.identifier + '.show'" style="font-size: 0.875rem; line-height: 1.6;"></label>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="custom-control custom-checkbox" v-if="permission.actions.includes('edit')">
                                        <input type="checkbox" class="custom-control-input" :id="permissionGroup.identifier + '.' + permission.identifier + '.edit'" v-model="form.permissions" :value="permissionGroup.identifier + '.' + permission.identifier + '.edit'">
                                        <label class="custom-control-label" :for="permissionGroup.identifier + '.' + permission.identifier + '.edit'" style="font-size: 0.875rem; line-height: 1.6;"></label>
                                    </div>
                                </td>
                            </tr>
                        </table>

                    </div>
                </div>
            </div>
        </div>

    </form>

</template>

<script>

    export default {

        name: 'RoleForm',

        props: [
            'formType',
            'role',
            'permissions'
        ],

        data() {
            let form;
            if (this.formType === 'edit') {
                form = new Vue.prototype.Form({
                    name: this.role.name,
                    description: this.role.description,
                    permissions: this.role.permissions
                });
            } else {
                form = new Vue.prototype.Form({
                    name: '',
                    description: '',
                    permissions: []
                });
            }
            return {
                eventHub: window.eventHub,
                form: form,
                stayOnPage: false
            }
        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.onSubmit();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        methods: {
            onSubmit() {
                if (this.formType === 'edit') {
                    this.form.put(route('user::roles.update', {id: this.role.id}))
                        .then((response) => {
                            if (this.stayOnPage) {
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', response.message, 'success');
                            } else {
                                window.location.href = route('user::roles.index') + '?status-message=success:' + response.message;
                            }
                        })
                        .catch(this.onResponseError);
                } else {
                    this.form.post(route('user::roles.store'))
                        .then((response) => {
                            if (this.stayOnPage) {
                                window.location.href = route('user::roles.edit', {id: response.data.role.id}) + '?status-message=success:' + response.message;
                            } else {
                                window.location.href = route('user::roles.index') + '?status-message=success:' + response.message;
                            }
                        })
                        .catch(this.onResponseError);
                }
            },

            onResponseError(response) {
                this.eventHub.$emit('processing-finish');
                this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
            }
        }
    }

</script>

<style scoped>

</style>
